"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeUntilStart = exports.checkIfEventLive = exports.getLocalizedTime = void 0;

var _momentTimezone = _interopRequireDefault(require("js-utils/moment-timezone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//mometimezone caches this value once called once.
//safe to call multiple times with no worries
//https://momentjs.com/timezone/docs/#/using-timezones/guessing-user-timezone/
var getUserTimezone = function getUserTimezone() {
  return _momentTimezone.default.tz.guess();
};

var getLocalizedTime = function getLocalizedTime(utcTimeStamp) {
  var userTimeZone = getUserTimezone();

  var localizedStartTime = _momentTimezone.default.utc(utcTimeStamp).tz(userTimeZone);

  return localizedStartTime;
};

exports.getLocalizedTime = getLocalizedTime;

var getCurrentLocalTime = function getCurrentLocalTime() {
  var userTimeZone = getUserTimezone();
  return _momentTimezone.default.utc().tz(userTimeZone);
};

var checkIfEventLive = function checkIfEventLive(localizedStartTimeString) {
  var currentTime = getCurrentLocalTime();

  var localizedDateObject = _momentTimezone.default.utc(localizedStartTimeString);

  return localizedDateObject.valueOf() < currentTime.valueOf();
};

exports.checkIfEventLive = checkIfEventLive;

var getTimeUntilStart = function getTimeUntilStart(localizedEventString) {
  var currentTime = getCurrentLocalTime();

  var localizedDateObject = _momentTimezone.default.utc(localizedEventString);

  return currentTime.diff(localizedDateObject, 'minutes') * -1;
};

exports.getTimeUntilStart = getTimeUntilStart;
//# sourceMappingURL=dates.js.map